import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from './components/ui/sonner';

// Pages
import Home from './pages/Home';
import Locations from './pages/Locations';
import LocationDetail from './pages/LocationDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Booking from './pages/Booking';
import BookingSuccess from './pages/BookingSuccess';
import AddLocation from './pages/AddLocation';
import HowItWorks from './pages/HowItWorks';
import About from './pages/About';
import Contact from './pages/Contact';
import TermsOwners from './pages/TermsOwners';
import TermsGuests from './pages/TermsGuests';
import Admin from './pages/Admin';
import BookingDetail from './pages/BookingDetail';
import ManageEvents from './pages/ManageEvents';
import OwnerCalendar from './pages/OwnerCalendar';
import EventDetail from './pages/EventDetail';
import Terms from './pages/Terms';

function App() {
  return (
    <div className="App">
      {/* Global fixed background layer – works on all browsers/devices
          (avoids iOS/Android quirks with background-attachment: fixed).
          On wide screens we show the panorama centered; on phones we shift
          the crop to the right where the van + campfire are. */}
      <div
        aria-hidden="true"
        className="wc-fixed-bg"
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: -1,
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.55)), url('https://customer-assets.emergentagent.com/job_elementor-site-1/artifacts/ff4gwxo8_ChatGPT%20Image%2031.%203.%202026%2023_45_22.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          pointerEvents: 'none',
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/location/:id" element={<LocationDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/booking/:id" element={<Booking />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/my-booking/:id" element={<BookingDetail />} />
          <Route path="/add-location" element={<AddLocation />} />
          <Route path="/edit-location/:id" element={<AddLocation />} />
          <Route path="/manage-events/:locationId" element={<ManageEvents />} />
          <Route path="/owner-calendar/:id" element={<OwnerCalendar />} />
          <Route path="/event/:id" element={<EventDetail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/obchodni-podminky" element={<Terms />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-owners" element={<TermsOwners />} />
          <Route path="/terms-guests" element={<TermsGuests />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
